const CHANGE = (state, step) => {
  const index = state.steps.findIndex(step => step.active === true)
  state.steps[index].active = false
  const change = state.steps.findIndex(s => s.component === step)
  state.steps[change].active = true
}

const SETFIELDS = (state, fields) => {
  state.formFields = { ...state.formFields, ...fields }
}

const SETSERVICOS = (state, servicos) => {
  state.servicos = servicos
}

const SETMODALIDADESENTREGA = (state, modalidades) => {
  state.modalidadesDeEntrega = modalidades
}

const SETCLEARFIELDS = (state) => {
  state.formFields = {
    useComercial: false,
    cnpj: null,
    cep: null,
    rua: null,
    rua2: null,
    numero: null,
    cidadeRegiao: null,
    complemento: null,
    modalidadeDeEntrega: null,
    descModalidade: null,
    servico: null,
    bairro: null,
    filesPFJ: [{ arquivo: [] }],
    filesPEM: [{ arquivo: [] }],
    formComer: {
      nome: null,
      email: null,
      tel: null
    },
    unitHabitacional: null,
    prevConclusao: null,
    areaTerreno: null,
    nomeEmpreendimento: null,
    idEmpreendimento: ''
  }
}

const SETREGIONS = (state, list) => {
  state.regions = list
}

const SETACTUALPROTOCOL = (state, protocol) => {
  state.protocolo = protocol
}

const SETLABELS = (state, labels) => {
  state.labels = labels
}

export default {
  CHANGE,
  SETFIELDS,
  SETSERVICOS,
  SETMODALIDADESENTREGA,
  SETCLEARFIELDS,
  SETREGIONS,
  SETACTUALPROTOCOL,
  SETLABELS
}
